// import React from "react";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import VendorDetailsUploadDoc from "./VendorDetailsUploadDoc";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
// importing scss
import "./VendorDocDetails.scss";

const documentTypes = [
  "Aadhaar Card",
  "PAN Card",
  "Driving Licence",
  "Voter ID",
];

const VendorDocDetails = ({ vendorProfileId }) => {
  const { user } = useAuthContext();

  const { document: userProfileDoc, error: userProfileError } = useDocument(
    "users",
    vendorProfileId
  );

  const { documents: organisations } = useCollection("organisations");
  const vendorOrganisations = organisations?.find(
    (org) => org.organisationId === user?.organisationId
  );
  const { updateDocument } = useFirestore("organisations");
  // New code for upload document start

  return (
    <div className="pd-cards animate-slide-in">
      <div className="pd-heading">
        <h2>Organisation Document</h2>
      </div>
      <div className="pd-emp_doc">
        <div className="pd-document">
          {documentTypes.map((docType) => {
            return (
              <VendorDetailsUploadDoc
                selectedDocType={docType}
                vendorOrganisationDoc={vendorOrganisations}
                vendorProfileId={vendorOrganisations}
                updateDocument={updateDocument}
                key={docType}
                folderName="vendor-docs"
                title={docType}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VendorDocDetails;
